import React, { useState, useEffect,useContext } from "react";
import Map from "../map";
import './paymentsmap.css';
import { useFetch } from "../../api/FetchApiData";
import { isMobile, MobileView } from "react-device-detect";
import Select from "react-select";

export default function PaymentsMap({close})
{
    const [payments,setPayments] = useState([]);
    const [selectOptions,setSelOptions] = useState([]);
    const fetchData = useFetch();

    const onMapMoveEnd = (bounds)=>{
        fetchData.PostData({bounds:bounds},'user/payment/1/').then((result)=>{
            if(result.result)
            {
                let arr = [];
                let ids = [];
                result.payments.forEach(element => {
                    if(element.address !== null || element.address !== undefined)
                    {
                        let address = {...element.address,mounts:[]};
                        address.type = 'payment';
                        if(!ids.includes(address.id))
                        {
                            address = {...address,mounts:[element.mount]}
                            arr.push(address);
                            ids.push(address.id);
                        }
                        else
                        {   
                            const ind = arr.findIndex((el)=>el.id===address.id); 
                            arr[ind].mounts.push(element.mount);
                        }
                    }
                });
                setPayments([...new Set([...payments, ...arr])])
            }
        })
    }

    useEffect(()=>{
        let ids = [];
        let arr = [];
        payments.map((address)=>{
        if(!ids.includes(address.id))
        {
            let font = 'small';
            if(isMobile)
                font = 'xx-small'
            arr.push({
            label:
            <div style={{fontSize:font}}>
                <h4 style={{margin:'0px'}}>{address.label}</h4>
                <label style={{color:'gray'}}>{address.phone+', ' }</label><br/>
                <label style={{color:'gray', fontStyle:'italic'}}>{address.display_name+', '}</label><br/>
                <label style={{color:'gray'}}>{address.mounts.map((order_)=>{return <span>{order_+', '}</span>})}</label>
            </div>,
            value:address.label,
            tag:address
        });
        ids.push(address.id);
    }
    });
    setSelOptions([...arr]);
    },[payments]);
    
    return(
        <div id="MapContent" style={{height:'90vh',width:'100%',marginTop:'0px'}}>
            <Map onMoveEnd={onMapMoveEnd} zoom={15} locations={payments} newLocation={null} />
            <div className='partners-map-controls'>
                <div style={{width:'80%',marginRight:'5px',marginTop:'5px',maxWidth:'250px'}}>
                    <Select options={selectOptions}  />
                </div>
                {//<input onClick={e=>{}} className='partners-map-itn' type='button'  value={'Itinéraire'} />
                }
            </div>
            <a className="globalclosemap" onClick={e=>{close()}}>
                &times;
            </a>
        </div>);
}